import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: '/gallery' },
    { path: '/kt', redirect: '/bakes' },
    {
      path: '/gallery',
      name: 'gallery',
      component: () => import('@/views/Gallery.vue')
    },
    {
      path: '/order',
      name: 'orderForm',
      component: () => import('@/views/Form.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/News.vue')
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/views/Orders.vue')
    },
    {
      path: '/orders/:id',
      name: 'order',
      props: true,
      component: () => import('@/views/Order.vue')
    },
    {
      path: '/events',
      name: 'events',
      component: () => import('@/views/Events.vue')
    },
    {
      path: '/events/:id',
      name: 'event',
      props: true,
      component: () => import('@/views/Event.vue')
    },
    {
      path: '/bakes',
      name: 'bakes',
      component: () => import('@/views/Bakes.vue')
    },
    {
      path: '/bakes/:id',
      name: 'bake',
      props: true,
      component: () => import('@/views/Bake.vue')
    },
    {
      path: '/subscribers',
      name: 'subscribers',
      component: () => import('@/views/Subscribers.vue')
    },
    {
      path: '/testimonials',
      name: 'testimonials',
      component: () => import('@/views/Testimonials.vue')
    },
    {
      path: '/testimonials/:id',
      name: 'testimonial',
      props: true,
      component: () => import('@/views/Testimonial.vue')
    }
  ]
})
